module.exports = __webpack_public_path__ + "img/film-threat-optimization-4.6397cfca.svg";